import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 11,
	viewBox: "0 0 14 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.1031 3.9349L0 6.0217L5.01718 11L14 2.0868L11.8969 0L5.01718 6.82641L2.1031 3.9349Z",
		fill: "white"
	})
});
export default SvgCheck;
